import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Spin } from 'antd';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function StripePaymentWrapper({ amount, currency = 'gbp', children }) {

  const options = useMemo(() => ({
    mode: 'payment',
    amount: Math.round(amount * 100),
    currency: currency,
    paymentMethodCreation: 'manual',
    loader: 'always',
    fonts: [
      {
        cssSrc:
          'https://swimbooker-fishery-details.s3.eu-west-2.amazonaws.com/fonts/gilroy.css',
      },
    ],
    appearance: {
      variables: {
        fontFamily: "'Gilroy-Regular', Ideal Sans, Arial, sans-serif",
        spacingUnit: '5px',
      },
    },
  }), [amount, currency])

  if (!amount) {
    // Elements requires amount to be non-zero so we don't return <Elements/> in this case. We also do not return the
    // unwrapped children as they will (likely) need to be wrapped in a valid <Elements/> component to function.
    return <Spin/>;
  }

  return (
    <Elements
      stripe={stripePromise}
      options={options}
    >
      {children}
    </Elements>
  );
}

export default StripePaymentWrapper;
